module.exports = __webpack_public_path__ + "img/ff.680a1cc8.png";